/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".textarea-append[_ngcontent-%COMP%]{background:var(--bg-color);width:100%;border:1px solid #dde2ec;display:flex;align-items:center;padding:5px 10px;justify-content:space-between}.textarea-append[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:12px;text-transform:uppercase;font-weight:700;color:var(--text-color)}.textarea-append[_ngcontent-%COMP%]   .badge-default[_ngcontent-%COMP%]{background:#d0d0d0}.cdk-overlay-container[_ngcontent-%COMP%]{position:relative!important;z-index:1!important}"];
export { styles as styles };
